import { StatsCardText } from './filters.contants';

// data related to the project
export const projectData = {
  name: 'La Caisse',
  tokenName: 'jwt',
};

// tabs related to the project
export const tabList = {
  All: 'All',
  Tout: 'Tout',
  Warning: 'Warning',
  credit: StatsCardText.creditClient,
};

// toast response
export const toastResponse = {
  success: {
    title: 'Success',
    message: 'Operation successful',
  },
  error: {
    title: 'Error',
    message: 'Operation failed',
  },
};

// schema for login
export const AuthSchema = {
  username: {
    min: 'Username must be at least 3 characters',
    max: 'Username must be less than 20 characters',
  },
  passCode: {
    min: 'Password must be at least 3 characters',
    max: 'Password must be less than 50 characters',
  },
};

// Redux constants
export const reduxSlice = {
  auth: 'auth',
};

// isadmin status
export const isAdminStatus = 'authorized';

// enum for languages
export enum Language {
  EN = 'en',
  FR = 'fr',
  COMMON = 'common',
}

export const messageGenerique = {
  error: "Une erreur s'est produite, merci de contacter un administrateur !",
};
